import { DateTime } from 'luxon';

export const availableAtDefaultDateAndTime: (timeZone: string) => string = (timeZone) =>
  DateTime.local().setZone(timeZone).plus({ days: 1 }).set({ hour: 7, minute: 0, second: 0, millisecond: 0 }).toUTC().toISO();
